import React, { useRef } from 'react';
import { BsFunnel } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Divider,
  HStack,
  Icon,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  Tooltip
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FilterLabel from '../../../../components/FilterLabel';
import FilterRadioGroup from '../../../../components/FilterRadioGroup';
import UserMultiSelectSearchDropdown from '../../../../components/UserMultiSelectSearchDropdown';
import { removeArrayItemAt } from '../../../../utils/arrayUtil';

const TemplatesFilter = ({ filterScope = 'folder', blueprint }) => {
  const initRef = useRef();
  const actions = filterScope === 'starterTemplates'
    ? {
      selectFilters: blueprint.selectPublishedRequirementTemplates,
      sortTemplates: blueprint.updatePublishedListSort,
      setCreators: blueprint.setPublishedTemplatesCreatorFilter
    }
    : {
      selectFilters: blueprint.selectRequirementTemplates,
      sortTemplates: blueprint.setCurrentRequirementTemplateSort,
      setCreators: blueprint.setCurrentRequirementTemplateCreatorFilter
    };

  const { sort, creatorsFilter } = useSelector(actions.selectFilters);
  const dispatch = useDispatch();

  return (
    <Popover
      initalFocusRef={initRef}
      placement="left-start"
    >
      {({ isOpen, onClose }) => (
        <>
          <Tooltip label="Filter Templates">
            <Box>
              <PopoverTrigger>
                <IconButton
                  aria-label="Filter Templates"
                  icon={<Icon as={BsFunnel} boxSize="24px" />}
                  variant="accent"
                />
              </PopoverTrigger>
            </Box>
          </Tooltip>
          <PopoverContent width="395px">
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader px={6} py={4} textAlign="left">
              <Text color="greyScale.900" textStyle="bodyXxl500">
                Filters
              </Text>
            </PopoverHeader>
            <PopoverBody pb={4} px={6} width="395px">
              <Box pb={3} pt={1}>
                <FilterLabel labelName="Template Name" />
                <FilterRadioGroup
                  ascValue="name"
                  descValue="-name"
                  value={sort}
                  onChange={val => dispatch(actions.sortTemplates(val))}
                />
              </Box>
              <Divider />
              <Box pb={4} pt={3}>
                <FilterLabel labelName="Creator" toolTip="Filter templates by creator" />
                <UserMultiSelectSearchDropdown
                  userSelectOptions={creatorsFilter}
                  onUserRemove={user => dispatch(actions.setCreators(
                    removeArrayItemAt(creatorsFilter, 'userId', user.userId)
                  ))}
                  onUserSelect={user => {
                    if (!creatorsFilter.find(creator => creator.userId === user.userId)) {
                      dispatch(actions.setCreators([user, ...creatorsFilter]));
                    }
                  }}
                />
              </Box>
              <HStack justifyContent="center" my={4} spacing={2}>
                <Button
                  variant="secondary"
                  onClick={() => {
                    dispatch(actions.setCreators([]));
                    dispatch(actions.sortTemplates('name'));
                  }}
                >
                  Reset Filters
                </Button>
                <Button onClick={() => onClose()}>Show Results</Button>
              </HStack>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

TemplatesFilter.propTypes = { filterScope: PropTypes.string };

export default TemplatesFilter;
